import Modal from "react-bootstrap/Modal";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { setSongsArray } from "../../store/actions";

function AddNewSection(props) {
  const [sectionName, setsectionName] = useState("");

  const submitSong = (event) => {
    event.preventDefault(); // Prevent form from refreshing the page

    if (!sectionName) {
      alert("Please enter a section name");
      return;
    }

    const updatedSongs = { ...props.songsArray };

    // Check if the section already exists
    if (updatedSongs[props.currentSongName][sectionName]) {
      alert("Section already exists. Please choose a different name.");
      return; // Exit the function
    }

    if (props.editSection) {
      // If the new name is different, update the song name
      updatedSongs[props.currentSongName][sectionName] =
        updatedSongs[props.currentSongName][props.editSection];
      delete updatedSongs[props.currentSongName][props.editSection];
      props.setEditSection("");
    } else {
      updatedSongs[props.currentSongName][sectionName] = [];
    }

    props.setSongsArray(updatedSongs);
    setsectionName("");
    props.toggleModal();
  };

  useEffect(() => {
    if (props.editSection) {
      setsectionName(props.editSection);
    }
  }, []);

  const handleInputChange = (e) => {
    setsectionName(e.target.value);
  };
  return (
    <div>
      <Modal
        size="lg"
        show={props.show}
        onHide={() => props.toggleModal()}
        aria-labelledby="vocal-range-popup"
      >
        <Modal.Header closeButton>
          <Modal.Title id="vocal-range-popup">Add new section</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={submitSong}>
            <label htmlFor="song-name">Section name:</label>
            <input
              type="text"
              id="song-name"
              name="song-name"
              value={sectionName || props.editSong}
              className="mb-4 form-control form-control-lg"
              onChange={handleInputChange}
            />
            <div>
              <button type="submit" className="btn btn_primary btn-lg">
                Add Section
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    songsArray: state.songsArray,
    currentSongName: state.currentSongName,
  };
};

const mapDispatchToProps = {
  setSongsArray,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddNewSection);
